import { getCommercial, postCommercial, putCommercial } from "../.";
import {
  ApplicationStatusDto,
  CardApplicationDocument,
} from "../generated-types";

const getUnfinishedApplications = (): Promise<unknown> => {
  return getCommercial("/protected/applications");
};

const manuallySignApplication = (
  applicationRef: CardApplicationDocument["applicationRef"],
): Promise<unknown> => {
  return postCommercial(
    `/protected/applications/${applicationRef}/manually-sign-application`,
  );
};

const completeCardApplication = (
  applicationRef: string,
  productRef: string,
): Promise<unknown> => {
  const request: ApplicationStatusDto = {
    status: "COMPLETED",
    productRef,
  };
  return putCommercial(
    `/protected/applications/${applicationRef}/status`,
    request,
  );
};

const ApplicationAPI = {
  getUnfinishedApplications,
  completeCardApplication,
  manuallySignApplication,
};

export default ApplicationAPI;
